import { type Product, type ProductReview } from "@prisma/client";
import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

interface Items {
  count: number;
  product: Product;
}

export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs))

export const capitalizeFirstLetter = (string: string): string => string.charAt(0).toUpperCase() + string.slice(1);

export const formatter = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
  maximumFractionDigits: 0,
});

export const shortName = (name: string) => name.split(" ").slice(0, 2).map(word => word[0]?.toUpperCase()).join("");

export function calculateAverageRating(reviews:  ProductReview[]) {
  if (!reviews?.length) return 0;

  const totalRating = reviews.reduce((sum, review) => sum + review.rating, 0);
  return totalRating / reviews.length;
}

export function calculatePayableCost(items: Items[]) {
  if (!Array.isArray(items)) return null;

  let totalAmount = 0;
  let discountAmount = 0;

  for (const item of items) {
    const { count, product } = item;
    if (product) {
      totalAmount += count * product.price;
      discountAmount += count * product.discount;
    }
  }

  const afterDiscountAmount = totalAmount - discountAmount;
  const taxAmount = afterDiscountAmount * 0.09;
  const payableAmount = afterDiscountAmount + taxAmount;

  return {
    totalAmount: totalAmount.toFixed(2),
    discountAmount: discountAmount.toFixed(2),
    afterDiscountAmount: afterDiscountAmount.toFixed(2),
    taxAmount: taxAmount.toFixed(2),
    payableAmount: payableAmount.toFixed(2),
  };
}